import React, { MouseEvent } from 'react';

import {
  RadioLabel,
  RadioButton,
  TemplateOptionContainer,
} from './TemplateChoiceOption.styled';
import { TemplateChoiceOptionProps } from './types';

export const TemplateChoiceOption = (props: TemplateChoiceOptionProps) => {
  const { onClick, optionKey, value, isPressed } = props;

  const handleClick = () => {
    onClick(optionKey);
  };

  const inputRef = React.createRef<HTMLInputElement>();

  const handleMouseDown = (e: MouseEvent<HTMLLabelElement>) => {
    e.preventDefault();
    e.stopPropagation();
    inputRef.current?.focus();
  };

  if (!value) return null;

  return (
    <TemplateOptionContainer>
      <RadioButton
        type="radio"
        id={optionKey}
        name="templates-list"
        value={value}
        checked={isPressed}
        isChecked={isPressed}
        onChange={handleClick}
        ref={inputRef}
      />
      <RadioLabel
        id={value}
        htmlFor={optionKey}
        onMouseDown={handleMouseDown}
        onMouseUp={handleClick}
      >
        {value}
      </RadioLabel>
    </TemplateOptionContainer>
  );
};
